<template>
	<div>
		<div class="register-page auth-pages" id="auth-page-loader">
			<Loader v-if="showLoader" />	
			<template v-if="displayAuth">
				<div class="auth-close" @click="updatePopup">
					<img src="../assets/cancel.svg" alt="close"/>
				</div>
				<div class="left-banner-section" v-if="displayValue">
					<div class="left-banner-images">
						<div class="section-holder">
							<div class="section-heading">
								<h3>Get access to everything WebMD offers</h3>
							</div>
							<div class="section-content">
								<ul>
									<li>
										<span class="list-icon"><img src="../assets/auth-icon-1.svg" alt="icon-1"/></span>
										<span class="list-text">Personalized tools for managing your health</span>
									</li>
									<li>
										<span class="list-icon"><img src="../assets/auth-icon-2.svg" alt="icon-2"/></span>
										<span class="list-text">Health and wellness updates delivered to your inbox</span>
									</li>
									<li>
										<span class="list-icon"><img src="../assets/auth-icon-3.svg" alt="icon-2"/></span>
										<span class="list-text">Saved articles, conditions and medications</span>
									</li>
									<li>
										<span class="list-icon"><img src="../assets/auth-icon-4.svg" alt="icon-4"/></span>
										<span class="list-text">Expert insights and patient stories</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div> 
				<div class="right-form-section"> 
					<div class="form-section">
						<div class="from-header">
							<h2>Sign Up for a WebMD account to save this article.</h2>
						</div>
						<div class="from-body">
							<form name="login" @submit.prevent="checkForm()">
								<div class="form-input-holder" >
                                    <div class="form-input">
                                        <input type="text" id="email" name="email" autocomplete="off" :data-value="formData['email']" aria-labelledby="email" v-model='formData["email"]' @blur="inputCheck($event, 'email','You need to enter your email')" @input="inputCheck($event, 'email',null)" class="member-form-input" :class="(this.emailError) ? 'input-error' : ''"/>
                                        <label class="placeholder-text" for="email" id="email1">
                                            <div class="text">Email</div>
                                        </label>
                                    </div>
                                    <div class="text-error" v-if="this.emailError" >
                                        {{emailError}}
                                    </div>
                                </div>
                                <div class="form-input-holder">
                                    <div class="form-input" >
                                        <div class="show-password" data-type='show' @click="ShowPassword">
                                            {{(this.showpassword==false) ? 'Show' : 'Hide'}}
                                        </div>
                                        <input type="password" id="password-reg" name="password" autocomplete="off" :data-value="formData['password']" aria-labelledby="password" v-model='formData["password"]' @blur="inputCheck($event, 'password', 'Minimum 8 letters & numbers')" @input="inputCheck($event, 'password',null)" class="member-form-input" :class="(this.passwordError) ? 'input-error' : ''"/>
                                        <label class="placeholder-text" for="email" id="password1">
                                            <div class="text">Password</div>
                                        </label>
                                    </div>
                                    <div class="text-error" v-if="this.passwordError" >
                                        {{passwordError}}
                                    </div>
                                </div>
                                <div class="form-input-holder">
                                    <div class="form-input">
                                        <input type="text" id="dob" name="dob" autocomplete="off" :data-value="formData['dob']" aria-labelledby="dob" v-model='formData["dob"]' @blur="inputCheck($event, 'dob', 'You need to enter your date of birth')" class="member-form-input" @input="autoFormateData($event, 'dob', null)" :class="(this.dobError) ? 'input-error' : ''"/>
                                        <label class="placeholder-text" for="dob" id="dob1">
                                            <div class="text">Date of birth (mm/dd/yyyy)</div>
                                        </label>
                                    </div>
                                    <div class="text-error" v-if="this.dobError">
                                        {{dobError}}
                                    </div>
                                </div>
                                <div class="form-button">
                                    <div class="reg-error text-error" v-if="this.regError == 'used'">
                                        <span>This email is already connected to an account. <a :href="encryptData()">Log in</a>.</span>
                                    </div>
                                    <div class="reg-error text-error" v-if="this.regError && this.regError != 'used'" v-html="this.regError"></div>
                                    <Button :disabled="!this.formIsValid" type="primary" size="large" nativeType="submit" :stretch="true">Sign Up</Button>
                                </div>
                                <div class="form-agree">
                                    By signing up, I agree to <a href="https://www.webmd.com/about-webmd-policies/about-terms-and-conditions-of-use" target="_blank">WebMD Terms of Use</a> & <a href="https://www.webmd.com/about-webmd-policies/about-privacy-policy" target="_blank">Privacy Policy</a>. I understand that I may opt out of WebMD subscriptions at any time.
                                </div>
                                <div class="form-account">
									<p>Already have an account? <a  @click="popupAction('reg-reg', displayValue, isMobileDisplay)">Log In</a></p>
								</div>
							</form>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="right-form-section"> 
					<div class="form-section">
						Article Saved Successfully
					</div>
				</div>
			</template>
			<ConfirmationOverlay
				v-if="displayPopup"
				pageName="login"
				:popupType="popupType"
				:displayPopup="displayPopup"
				:userEmail="formData.email"
				:userId="userIdField"
				:savedAccessToken="savedAccessToken"
				:contentData="contentData"
				:savedDrugs="savedDrugs"
				@updateDisplay="updateDisplay"
				@saveSuccess="toggleNotification"
				@updateAction="updateSavePopup"
				@closeAuthPopup="updatePopup"
			/>
		</div>
	</div>
</template>
<script>
import { Button } from 'webmd-elements';
import axios from 'axios';
import registrationMixins from './mixins/registration.mixins.es6';
import ConfirmationOverlay from './ConfirmationOverlay.vue'
import Loader from './Loader.vue'
import api from '../api.es6';
export default {
	components:{
		Button,
		ConfirmationOverlay,
		Loader
	},
	props:{
		displayMainConfPopup : Boolean,
		savedAccessToken : String,
		displayValue : Boolean,
		contentData:Object,
		savedDrugs:Object,
		isMobileDisplay: Boolean,
	},
	data() {
		return {
			displayAuth : true, 
			showLoader : false,
			formData:{
				email : '',
				password: '',
                dob : ''
			},
			popupType : 'soft',
			displayPopup : false,
            regError : '',
			searchterm : '',
			email : '',
			emailError: false,
			passwordError: false,
			dobError : false,
			showpassword : false,
			emailFormateError: false,
			formIsValid : false,
			combinationError: '',
			rememberme: false,
			userId: '',
			successMsg: '',
			errorEmailMsg: false,
            userIdField : ''
		};
	},
	mixins: [registrationMixins],
	computed: {
		Button
	},
	emits: ['updateAuthpopupComponent', 'updateAction', 'saveSuccess'],
	methods:{
		updatePopup(){
			this.$emit('updateAuthpopupComponent', false)
		},
		udpateCheckbox(){
			document.getElementById("rememberme").checked = (document.getElementById("rememberme").checked) ? false : true
		},
		updateSavePopup(){
			this.$emit('updateAction', 'save')
		},
		updateDisplay(displayPopup){
			if(this.savedAccessToken){
				this.updatePopup();
				this.displayPopup = displayPopup;
			}
			else{
				this.displayPopup = displayPopup;
			}
		},
		toggleNotification(flag) {
			this.$emit('saveSuccess', flag);
		},
		inputCheck(event, modalValue, displayError){
			let checkValidation = []
			checkValidation = Object.keys(this.formData).map((key, index) => {
				if(key=='email' && modalValue==key) {
					if (!this.formData[key]) {
						this.emailError = displayError;
						this.$vwmdTrack({ sSource: 'reg-error_1' });
						return false;
					}
					const checkValidationEmail = String(this.formData[key]).toLowerCase().match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/);
					if (!checkValidationEmail) {
						this.emailError = displayError || "This email is invalid. Make sure it's written like example@email.com";
						this.$vwmdTrack({ sSource: 'reg-error_2' });
						return false;
					}
					this.emailError = '';
					return true;
				}

				if(key=="password" && modalValue==key) {
					if(this.formData[key]){
						if(this.formData[key].length<8){
							this.passwordError = (displayError!=null) ? 'Minimum 8 letters & numbers' : ''
							this.$vwmdTrack({ sSource: `reg-error_7`});

							return false
						}
						if(this.formData[key].length>=8 && !this.checkPasswordStrength(this.formData[key])){
							this.passwordError =  (displayError!=null) ? 'Minimum 8 letters & numbers' : ''
							this.$vwmdTrack({ sSource: `reg-error_7`});
							return false
						}
						else{
							this.passwordError = ''
							return true
						}
					}
					else {
						this.passwordError = displayError
						this.$vwmdTrack({ sSource: `reg-error_6`});
						return false
					}
				}

				if(key=="dob" && modalValue==key){
					if(this.formData[key]){
						let clacDateTime = this.calcDate(this.formData[key]);
						let validateDate = this.validatedate(this.formData[key]);
						if(!validateDate){
							this.dobError =  (displayError!=null) ? 'Invalid date format' : ''
							this.$vwmdTrack({ sSource: `reg-error_10`});
							return false
						}
						else if(this.calcDate(this.formData[key]) < 13){
							this.dobError = (displayError!=null) ? 'You must be 13 or over to create an account' : ''
							this.$vwmdTrack({ sSource: `reg-error_10`});
							return true
						}
						else{
							this.dobError = ''
							return true
						}

					}
					else{
						this.dobError = displayError
						this.$vwmdTrack({ sSource: `reg-error_10`});

						return false
					}
				}

				if(event){
					if(key=='email'){
						if((this.formData[key]!='' &&  this.formData[key]!=0)){
							let checkValidationEmail = String(this.formData[key]).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
							if(!checkValidationEmail){
								return false
							}
						}
						else{
							return false
						}
					}
					else if(key=="password" ){
						if(this.formData[key]){
							if(this.formData[key].length<8){
								return false
							}
							else{
								return true
							}
						}
						else{
							return false
						}
					}
					else if(key=="dob"){
						if(this.formData[key]){
							let clacDateTIme = this.calcDate(this.formData[key]);
							let validateDate = this.validatedate(this.formData[key]);
							if(!validateDate){
								return false
							}
							else if(this.calcDate(this.formData[key]) < 13){
								return true
							}
							else{
								return true
							}
						}
						else{
							return false
						}
					}
				}
			})

			this.formIsValid = (checkValidation.includes(false)) ? false : true;
		},
		encryptData(){
			if(!this.formData.email){
				return this.updateUrl('/password-reset');
			}
			else{
				return 	this.updateUrl('/password-reset',encodeURIComponent(btoa(this.formData.email)))
			}
		},
        calcDate(dob){
			let date1 = new Date();
			let date2 = new Date(dob);
			let Difference_In_Time = date1.getFullYear() - date2.getFullYear();
			return  Difference_In_Time;
		},
        checkPasswordStrength(text){
			let checkPassword =  /^(?=.*?\d)(?=.*?[a-zA-Z])[a-zA-Z\d]+$/.test(text);
			return checkPassword;
		},
		ShowPassword(){
			let checkPassword = document.getElementById('password-reg');
			if(checkPassword){
				checkPassword.type = (this.showpassword==true) ? 'password' : 'text'
				this.showpassword = !this.showpassword;
			}
		},
		checkForm() {
			if(!this.formIsValid){
				// this.omnitureCall('register-core', 'reg-error')
			}
			else{
				const params = new URLSearchParams();
				params.append('email_address', this.formData.email);
				params.append('password', this.formData.password);
				params.append('last_name', '');
				params.append('first_name', '');
				params.append('gender', '');
				params.append('dtob', this.formData.dob.split(' ').join(''));
				params.append('privacy_policy_accept', true);
				params.append('term_condition_accept', true);
				params.append('remember', 1);
				params.append('getcookie', true);
				const query = '/api/reg/regapi.svc/secure/json/register';
				let searchapi = this.checkUrl('www',query);
				this.showLoader = true
				let webmdAuthp = this.getCookie('ab');
				api.getHeaders().then(headers => axios.post(`${searchapi}`, params, headers)).then((response) => {
					if (response && response.data.d.code === 1) {
						let webmdAuthp = this.getCookie('ab')
						if(this.isMobileDisplay){
							this.$vwmdPageLink({moduleName: `reg-success2_f-2`});
						}
						else if(webmdAuthp){
							this.$vwmdPageLink({moduleName: (this.displayValue) ? `reg-success2b_f-2b` : `reg-success2a_f-2a`});						
						}
						else{
							this.$vwmdPageLink({moduleName: 'reg-success2_f-2'});
						}

						this.userIdField = response.data.d.data.userid;
						const authCode = response.data.d.data.authcode;
						const regCookies = response.data.d.data.cookies;
						if(regCookies){
							regCookies.map((cklist, index)=> {
								document.cookie = `${cklist.Name}=${cklist.Value}; expires=${cklist.Expires}; path=/; domain=.webmd.com; SameSite=${cklist.SameSite}; Secure=${cklist.Secure}`;
								if(index+1 == regCookies.length){
									if(authCode){
										document.cookie = `WBMD_AUTHC=${authCode}; expires=${cklist.Expires}; path=/; domain=.webmd.com; SameSite=${cklist.SameSite}; Secure=${cklist.Secure}`;
										document.cookie = `WBMD_NWEUS=true; expires=${cklist.Expires}; path=/; domain=.webmd.com; SameSite=${cklist.SameSite}; Secure=${cklist.Secure}`;
										this.popupType = 'hard'
										this.displayPopup = true
                                        this.showLoader = false
									}
								}
							})
						}
					}
					else {
						this.showLoader = false
						const updateMsgCode = response.data.d.code;
						this.formIsValid = false
						if(this.regErrorMessage(updateMsgCode, this.formData.email)){
							this.regError = this.regErrorMessage(updateMsgCode, this.formData.email);
							this.$vwmdTrack({ sSource: `reg-error_23`});
						}
						else{
							if(response.data.d.data.data && response.data.d.data.data.length){
								if(response.data.d.code=='30'){
									this.emailError = `<span>${response.data.d.data.data[0]}</span>`;
									this.$vwmdTrack({ sSource: `reg-error_23`});
									this.formIsValid = false
								}
								else{
									this.regError = `<span>${response.data.d.data.data[0]}</span>`;
									this.$vwmdTrack({ sSource: `reg-error_23`});
								}
							}
							else if(response.data.d.data.errors && response.data.d.data.errors.length){
								this.regError = `<span>${response.data.d.data.msg}</span>`;
								this.$vwmdTrack({ sSource: `reg-error_23`});
							}
							else if(response.data.d.data.data && response.data.d.data.data.length){
								this.regError = `<span>${response.data.d.data.msg}</span>`;
								this.$vwmdTrack({ sSource: `reg-error_23`});
							}
							else if(response.data.d.data.msg){
								this.regError = `<span>${response.data.d.data.msg}</span>`;
								this.$vwmdTrack({ sSource: `reg-error_23`});
							}
						}
					}
				}).catch((error) => {
					this.showLoader = false
				});
			}
		}
	}
};
</script>
<style scoped lang="scss">
.register-page{
    .right-form-section{
		padding: 73px 0px 74px 0px;
		h2{
			margin-bottom: 18px;
			@media(max-width:992px){
				margin-bottom: 24px !important;
			}
		}
		@media(max-width:992px) and (min-width:768px){
			padding: 0px 20px;
			margin:64px 0 20px 0;
		}
		@media(max-width:767px){
			padding: 0px 20px;
			margin:64px 0 20px 0;
		}
        .from-body{
            .form-input-holder{
                &:nth-child(2), &:nth-child(3) {
                    margin-top: 18px;
                    @media(max-width:992px){
                        margin-top: 24px !important;
                    }
                }
                &:nth-child(3) {
                    margin-bottom: 18px !important;
                    @media(max-width:992px){
                        margin-bottom: 24px !important;
                    }
                }
            }
            .form-agree{
                margin-top: 10px;
                font-weight: 400;
                font-size: 13px;
                line-height: 20px !important;
                color:#1B1B1B;
                font-weight:400;
                a{
                    color:#3557FF;
                }
                @media(max-width:992px){
                    margin-top: 24px !important;
                    line-height: 20px !important;
                }
            }
        }
        .reg-error.text-error {
            position: relative!important;
            padding-top: 0!important;
            bottom: 0!important;
            top: -15px!important;
        }
    }
}
</style>
